import React, { Fragment, useContext, useRef } from 'react';
import InputField from '../../../../lib/ui/inputs/Input';
import { LangCtx } from "../../../../lib/context";
// import "../Styles.css";
// import "./doctorUploadsStyles.css";

const UploadForm = (props) => {
    const { l } = useContext(LangCtx);
    const { role } = props;
    const fileRef = useRef(null);

    const handleImage = (e) => {
        let fileEle = fileRef.current;
        if (fileEle) {
            fileEle.click()
        }
    }

    const handleupload = (e) =>{
        props.handleUploadFile(e)
    }

    return (
        <Fragment>
            <div className="uploadFormHdng">
                {/*** Hide this text on Patient Side **/}
                {role && role === 'P' ?
                    <p className="subInfoTxt">{l.pat_upload_desc}</p>
                    :
                    <p className="subInfoTxt">{l.upload_desc}</p>
                }
                {/*** If Patient ****/}
            </div>
            <div>
                <form className="fileUploadForm">
                    <div className="fileInput">
                        <input className="uploadInput" ref={fileRef} title= "Upload a file" type="file" accept="image/*, video/*" id="file" onClick={(e) => e.target.value = null} onChange={(e) => {handleupload(e) }}/>
                        <img src="/images/icons/fileupload.png" className="invertGray" title= "Upload a file" alt="icon" htmlFor="file" onClick={handleImage}/>
                        <label htmlFor="file">{l.browseTxt}</label>
                        {role === "D" || role === "C" ?
                        // <small>{l.upload_info}</small>
                        <small>only video and image files are allowed</small>
                        :
                        <small>{l.patient_upload_info}</small>
                        }
                        
                        {/* <button class="btnFilled md ripple" type="submit">
                            <span>Upload File</span>
                        </button> */}
                        {/* <div class="box__uploading">Uploading…</div>
                    <div class="box__success">Done!</div>
                    <div class="box__error">Error! </div> */}
                    </div>
                    {role === "D" || role === "C" && <div className="urlInput">
                        <p>{l.link_web}</p>
                        <InputField
                            placeholder={l.youtube_url}
                            type="text"
                            name="youtubeUrl"
                            value={props.youtubeUrl}
                            onChange={(e) => props.handleChange(e)}
                        />
                        <div className="flexZA">
                            <button className="btnFilled md ripple btnSelfRight" onClick={(e) => props.handleYoutubeUrl(e)}>
                                <span>{l.Upload}</span>
                            </button>
                        </div>
                    </div>}
                </form>
            </div>
        </Fragment>
    )
}

export default UploadForm;